import type { Role } from '@vlm/api';
import { Bell, ChartColumn, Cpu, Hexagon, Link2, Map, ReceiptText, Route, SlidersHorizontal, Truck, Users, type LucideIcon } from 'lucide-react';
import type { Key } from '../i18n';
import { ADMINS, MANAGERS } from '../lib/auth';

export interface NavItem {
  to: string;
  label: Key;
  icon: LucideIcon;
  /** Who sees it; everyone signed in when absent. The API enforces the same rules. */
  roles?: readonly Role[];
}

/** The rail, in the old admin's order; who sees what is unchanged from it. Billing came with the SaaS platform (docs/SAAS.md). */
export const NAV: NavItem[] = [
  { to: '/live', label: 'nav.live', icon: Map },
  { to: '/vehicles', label: 'nav.vehicles', icon: Truck, roles: MANAGERS },
  { to: '/devices', label: 'nav.devices', icon: Cpu, roles: MANAGERS },
  { to: '/assignments', label: 'nav.assignments', icon: Link2, roles: MANAGERS },
  { to: '/trips', label: 'nav.trips', icon: Route },
  { to: '/geofences', label: 'nav.geofences', icon: Hexagon, roles: MANAGERS },
  { to: '/alerts', label: 'nav.alerts', icon: Bell },
  { to: '/reports', label: 'nav.reports', icon: ChartColumn },
  { to: '/users', label: 'nav.users', icon: Users, roles: ADMINS },
  { to: '/settings/alerts', label: 'nav.alertSettings', icon: SlidersHorizontal, roles: ADMINS },
  { to: '/billing', label: 'nav.billing', icon: ReceiptText, roles: ADMINS },
];

export const visibleNav = (role: Role | undefined) => NAV.filter((item) => !item.roles || (role !== undefined && item.roles.includes(role)));
